module.exports = __webpack_public_path__ + "8339c746faf1d1c2cab15a6b5fdd29e8.svg";